module.exports = __webpack_public_path__ + "static/media/bg1.45cade7b.jpg";